import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import dynamic from 'next/dynamic';
import './twigFixes';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import Loader from './components/Loader';
import { jsx as _jsx } from "react/jsx-runtime";
export { default as initLegacy } from './helpers/initLegacy';
export var twigComponentsMap = {
  'action-3.twig': 'Action3',
  'cta-3.twig': 'Cta3',
  'cta-4.twig': 'Cta4',
  'cta-6.twig': 'Cta6',
  'feature-3.twig': 'Feature3',
  'form-3.twig': 'Form3',
  'form-marketo.twig': 'FormMarketo',
  'hero-5.twig': 'Hero5',
  'hero-6.twig': 'Hero6',
  'hero-10.twig': 'Hero10',
  'hero-11.twig': 'Hero11',
  'hero-marketo.twig': 'HeroMarketo',
  'info-1.twig': 'Info1',
  'review-1.twig': 'Review1',
  'review-3.twig': 'Review3',
  'slider-3.twig': 'Slider3',
  'table-1.twig': 'Table1',
  'table-2.twig': 'Table2',
  'templates-promo.twig': 'TemplatesPromo',
  'text-block-1.twig': 'TextBlock1',
  'text-block-2.twig': 'TextBlock2',
  'home-btf': 'HomeBTF'
};
export var refactoredComponentsMap = {
  'card-1.twig': 'Resources',
  'card-5.twig': 'RelatedContent',
  'content-1.twig': 'FAQ',
  'cta-5.twig': 'CtaWithPattern',
  'hero-2.twig': 'HeroWithTypingAnimation',
  'hero-4.twig': 'Hero',
  'hero-8.twig': 'HeroFirstLevel',
  'hero-9.twig': 'HeroSecondLevel',
  'info-2.twig': 'OneColumnEmbed',
  'review-4.twig': 'Testimonial',
  'text-block-3.twig': 'TextBlockWithScrollingItems',
  'hero-12': 'HeroWithLogos',
  'super-component': 'SuperComponent',
  'page-navigator': 'Navigator',
  'info-slider': 'InfoSlider',
  'inline-form-to-signup': 'InlineFormToSignUp'
};

var loading = function loading() {
  return /*#__PURE__*/_jsx(Loader, {
    padding: "spacingL"
  });
};

var refactoredComponents = {
  SuperComponent: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.SuperComponent;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  TabsComponent: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.TabsComponent;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  OpenJobs: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.OpenJobs;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  Navigator: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.Navigator;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  InfoSlider: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.InfoSlider;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  InlineFormToSignUp: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.InlineFormToSignUp;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  CtaWithPattern: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.CtaWithPattern;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  FAQ: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.FAQ;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  Hero: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.Hero;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  HeroFirstLevel: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.HeroFirstLevel;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  HeroSecondLevel: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.HeroSecondLevel;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  HeroWithLogos: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.HeroWithLogos;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  HeroWithAnimationImage: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.HeroWithAnimationImage;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  OneColumnEmbed: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.OneColumnEmbed;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  RelatedContent: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.RelatedContent;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  Resources: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.Resources;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  Testimonial: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.Testimonial;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  TestimonialsCarousel: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.TestimonialsCarousel;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  TextBlockWithScrollingItems: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.TextBlockWithScrollingItems;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  HeroWithTypingAnimation: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.HeroWithTypingAnimation;
    });
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  // Needed these for lp builder pages
  AcquisitionHeader: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.AcquisitionHeader;
    });
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  }),
  AcquisitionFooter: dynamic(function () {
    return import('@miro-site/components').then(function (module) {
      return module.AcquisitionFooter;
    });
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('@miro-site/components')];
      }
    }
  })
};
export var components = _objectSpread({
  Action3: dynamic(function () {
    return import('./components/sections/action-3/Action3');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/action-3/Action3')];
      }
    }
  }),
  Cta3: dynamic(function () {
    return import('./components/sections/cta-3/Cta3');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/cta-3/Cta3')];
      }
    }
  }),
  Cta4: dynamic(function () {
    return import('./components/sections/cta-4/Cta4');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/cta-4/Cta4')];
      }
    }
  }),
  Cta6: dynamic(function () {
    return import('./components/sections/cta-6/Cta6');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/cta-6/Cta6')];
      }
    }
  }),
  Feature2: dynamic(function () {
    return import('./components/sections/feature-2/Feature2');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/feature-2/Feature2')];
      }
    }
  }),
  Feature3: dynamic(function () {
    return import('./components/sections/feature-3/Feature3');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/feature-3/Feature3')];
      }
    }
  }),
  Form3: dynamic(function () {
    return import('./components/sections/form-3/Form3');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/form-3/Form3')];
      }
    }
  }),
  FormMarketo: dynamic(function () {
    return import('./components/sections/form-marketo/FormMarketo');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/form-marketo/FormMarketo')];
      }
    }
  }),
  Hero5: dynamic(function () {
    return import('./components/sections/hero-5/Hero5');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/hero-5/Hero5')];
      }
    }
  }),
  Hero6: dynamic(function () {
    return import('./components/sections/hero-6/Hero6');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/hero-6/Hero6')];
      }
    }
  }),
  Hero10: dynamic(function () {
    return import('./components/sections/hero-10/Hero10');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/hero-10/Hero10')];
      }
    }
  }),
  Hero11: dynamic(function () {
    return import('./components/sections/hero-11/Hero11');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/hero-11/Hero11')];
      }
    }
  }),
  HeroMarketo: dynamic(function () {
    return import('./components/sections/hero-marketo/HeroMarketo');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/hero-marketo/HeroMarketo')];
      }
    }
  }),
  Info1: dynamic(function () {
    return import('./components/sections/info-1/Info1');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/info-1/Info1')];
      }
    }
  }),
  Review1: dynamic(function () {
    return import('./components/sections/review-1/Review1');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/review-1/Review1')];
      }
    }
  }),
  Review3: dynamic(function () {
    return import('./components/sections/review-3/Review3');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/review-3/Review3')];
      }
    }
  }),
  Slider3: dynamic(function () {
    return import('./components/sections/slider-3/Slider3');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/slider-3/Slider3')];
      }
    }
  }),
  Table1: dynamic(function () {
    return import('./components/sections/table-1/Table1');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/table-1/Table1')];
      }
    }
  }),
  Table2: dynamic(function () {
    return import('./components/sections/table-2/Table2');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/table-2/Table2')];
      }
    }
  }),
  TemplatesPromo: dynamic(function () {
    return import('./components/sections/templates-promo/TemplatesPromo');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/templates-promo/TemplatesPromo')];
      }
    }
  }),
  TextBlock1: dynamic(function () {
    return import('./components/sections/text-block-1/TextBlock1');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/text-block-1/TextBlock1')];
      }
    }
  }),
  TextBlock2: dynamic(function () {
    return import('./components/sections/text-block-2/TextBlock2');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/text-block-2/TextBlock2')];
      }
    }
  }),
  HomeBTF: dynamic(function () {
    return import('./components/sections/home-btf/HomeBTF');
  }, {
    loading: loading,
    loadableGenerated: {
      webpack: function webpack() {
        return [require.resolveWeak('./components/sections/home-btf/HomeBTF')];
      }
    }
  })
}, refactoredComponents);